import config from "../Config/config";

const fetchUserData = async (setUser, setLoading) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/user/getUserData`, {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) throw new Error("Unauthorized");

    const userData = await response.json();
    setUser(userData);
  } catch (error) {
    console.error("Authentication error:", error);
    setUser(null); // Ensure user is null when not authenticated
  } finally {
    setLoading(false);
  }
};

export { fetchUserData };
